"use client";
import React, { useState, useEffect, useRef } from "react";
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaSave,
  FaSync,
  FaTimes,
  FaPlusCircle,
  FaCamera,
} from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import { API_BASE_URL } from "../utils/CONSTANTS";
import { AiOutlinePrinter } from "react-icons/ai";
import Header from "../components/header";

function PackingEntry() {
  const navigate = useNavigate();
  const [packerNames, setPackerNames] = useState([]);
  const [isMaximized, setIsMaximized] = useState(false);
  const [allCardNumbers, setAllCardNumbers] = useState([]);
  const [lotnolist, setLotNoList] = useState([])
  const [perweight, setperweight] = useState();
  const [isCustomQtyExists, setIsCustomQtyExists] = useState(null);
  const [isCustomPkgQtyExists, setIsCustomPkgQtyExists] = useState(null);
  const [showScanner, setShowScanner] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const scannerRef = useRef(null);
  const scanHandledRef = useRef(false);

  const [formData, setFormData] = useState({
    vnum: "",
    vNo: "",
    date: "",
    packerName: "",
    cardNo: "",
    lotNo: "",
    qty: "",
    wt: "",
    packingQuantity: "",
    packingSize: "",
    totalquantity: "",
    remark: "",
    pack: "",
    customQty: "",
    customPackingQuantity: "",
  });

  const [formError, setFormError] = useState({
    vnum: "",
    vNo: "",
    date: "",
    packerName: "",
    cardNo: "",
    lotNo: "",
    qty: "",
    wt: "",
    packingQuantity: "",
    pack: "",
    customQty: "",
    customPackingQuantity: "",
    totalquantity: "",
  });

  const [isFormEnabled, setIsFormEnabled] = useState(false);
  const [isNewEntry, setIsNewEntry] = useState(false);
  const [allVNumbers, setAllVNumbers] = useState([]);
  const [allVNums, setAllVNums] = useState([]);
  const [allpackerName, setAllpackerName] = useState([]);
  const [totalquantity, settotalquantity] = useState();
  const [remainingqty, setRemainingQTY] = useState(0)

  const [allparty, setparty] = useState([]);

  useEffect(() => {
    fetchAllVNumbers();
    fetchAllCardNumbers();
    fetchPartynames();
    fetchAllPackagesvno();
  }, []);
  useEffect(() => {
    if (formData.cardNo == "") return
    axios.get(`${API_BASE_URL}/api/product/getlotno/${formData.cardNo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    ).then(res => {
      console.log(res)
      setLotNoList(res.data.lotNos)
    }, err => { })
  }, [formData.cardNo])
  useEffect(() => {
    console.log(formData.totalquantity, totalquantity)
    if (Number(formData.totalquantity) > 2 * Number(totalquantity)) {
      alert(`packing quantity cannot be exceed by ${2 * Number(totalquantity)}`)
    }
  }, [formData.totalquantity])
  useEffect(() => {
    const cardno = formData.cardNo
    if (!cardno) return;
    axios.get(
      `${API_BASE_URL}/api/package/getPackages/${cardno}`
    ).then((res) => {
      let pkgqty = 0
      const packingdata = res.data.data
      if (packingdata.length) {
        for (const pkg of packingdata) {
          pkgqty += Number(pkg.totalquantity)
        }
      }
      console.log(res)
      setRemainingQTY(totalquantity - pkgqty)
    })
  }, [formData.cardNo, totalquantity])

  useEffect(() => {
    console.log("total qunatity")
    console.log(formData)
    handleInputChange({
      target: {
        name: "totalquantity",
        value: Number(formData.customPackingQuantity || formData.packingQuantity || 0) * Number(formData.pack || 0)
      }
    })
  }, [formData.customPackingQuantity, formData.packingQuantity, formData.pack])
  const validateField = (name, value) => {
    if (name === "customPackingQuantity") {
      if (formData?.packingQuantity === "custom" && !value) {
        return `${name} is required.`;
      }
      // if(formData?.packingQuantity === "custom" && Number(value) > 2*Number(totalquantity)){
      //   return `packing quantity cannot be exceed by ${2*Number(totalquantity)}`;
      // }
      return "";
    }
    else if (name === "customQty") {
      if (formData?.qty === "custom" && !value) {
        return `${name} is required.`;
      }
      return "";
    } else if (name === "packingQuantity") {
      if (formData?.packingQuantity !== "custom" && !value) {
        return `${name} is required.`;
      }
      if (formData?.packingQuantity !== "custom" && Number(value) > 2 * Number(totalquantity)) {
        return `packing quantity cannot be exceed by ${2 * Number(totalquantity)}`;
      }
      return "";
    } else if (name === "qty") {
      if (formData?.qty !== "custom" && !value) {
        return `${name} is required.`;
      }
      return "";
    }
    if (!value || value.length === 0) {
      return `${name} is required.`;
    }
  };

  const fetchDataByCardNo = async (cardNo) => {
    if (cardNo) {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/order/getOrder/${cardNo}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
          }
        );
        const data = await response.json();

        var num1 = data.cardData.quantity;
        var num2 = data.cardData.wtReqd;
        var parweight = parseFloat(num1) / parseFloat(num2);
        console.log({ data });

        settotalquantity(data.cardData.quantity);
        return parweight;
      } catch (error) {
        console.error("Error fetching specific data:", error);
      }
    } else {
    }
  };

  const [tableData, setTableData] = useState([]);

  const calculateWeight = async () => {

    let packingWeight = (Number(formData.wt) / Number(formData.qty == "custom" ? formData.customQty : formData.qty)) * Number(formData.totalquantity);

    if (packingWeight) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        packingSize: (packingWeight / 1000).toFixed(2),
      }));
    }
  };

  const fetchPartynames = async (req, res) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/order/getPartynames`,
        {
          withCredentials: true,
        }
      );

      const result = response.data.cardNos.map((item) => item.partySpec);
      setparty(result);
    } catch (err) {
      console.log(err.message);
      toast("Some error occured, please try again later ");
    }
  };

  const fetchAllPackagesvno = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/package/vnos/all`, {
        withCredentials: true,
      });
      const result = await response.data.cardNos;
      console.log(result);
      // Map vNo values and sort in descending order
      var vnos = result.map((item) => item.vNo).sort((a, b) => Number(b) - Number(a));
      var packername = result.map((item) => item.packerName);
      setAllVNums(vnos);
      setAllpackerName(packername);
    } catch (error) {
      console.error("Error fetching V. Numbers:", error);
    }
  };

  const fetchAllCardNumbers = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/order/getCardno`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      const sortedCardNos = data.cardNos.sort(
        (a, b) => Number(b.cardNo) - Number(a.cardNo)
      );

      setAllCardNumbers(sortedCardNos);
    } catch (error) {
      console.error("Error fetching card numbers:", error);
    }
  };


  const fetchAllVNumbers = () => {
    axios
      .get(`${API_BASE_URL}/api/dispatch/getvno`, {
        withCredentials: true,
      })
      .then((response) => {
        const nums = response.data.vnum.map((item) => item.vno);
        setAllVNumbers(nums);
      })
      .catch((error) => console.error("Error fetching V. Numbers:", error));
  };

  const fetchAllData = () => {
    axios
      .get(`${API_BASE_URL}/api/packing/all`)
      .then((response) => {
        setTableData(response.data);
      })
      .catch((error) => console.error("Error fetching all data:", error));
  };

  const fetchPackageData = async (vno) => {
    if (vno) {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/package/getPackage/${vno}`,
          { withCredentials: true }
        );
        const formattedDate = new Date(response.data.data.date)
          .toISOString()
          .split("T")[0];

        const isCustomQuantityExists = !!response?.data?.data?.customQty

        setIsCustomQtyExists(isCustomQuantityExists)

        const isCustomPackageQuantityExists = !!response?.data?.data?.customPackingQuantity

        setIsCustomPkgQtyExists(isCustomPackageQuantityExists)


        setFormData((prevFormData) => ({
          ...prevFormData,
          vNo: response.data.data.vNo || "",
          date: formattedDate || "",
          packerName: response.data.data.packerName || "",
          cardNo: response.data.data.cardNo || "",
          qty: response.data.data.qty || "",
          wt: response.data.data.wt || "",
          lotNo: response.data.data.lotNo || "",
          packingQuantity: response.data.data.packingQuantity || "",
          packingSize: response.data.data.packingSize || "",
          remark: response.data.data.remark || "",
          pack: response.data.data.pack || "",
          customQty: prevFormData.customQty, // Preserve existing customQty
          customPackingQuantity: prevFormData.customPackingQuantity, // Preserve existing customPackingQuantity
        }));
        setIsFormEnabled(true);
        setIsNewEntry(false);
        // resetForm();
      } catch (error) {
        console.error("Error fetching specific data:", error);
      }
    } else {
      resetForm();
    }
  };



  useEffect(() => {
    fetchDataByCardNo(formData?.cardNo);
    console.log("formData", formData)
  }, [formData.cardNo]);

  useEffect(() => {
    calculateWeight();
  }, [
    formData.qty,
    formData.wt,
    formData.customQty,
    formData.totalquantity
  ]);

  useEffect(() => {
    // Fetch all packer names from the database to populate the dropdown
    axios.get(`${API_BASE_URL}/api/package/getPackerNames`)
      .then(response => {
        const allPackerNames = response.data.map(item => item.packerName);
        const uniquePackerNames = [...new Set(allPackerNames)];  // Get unique names
        setPackerNames(uniquePackerNames);
      })
      .catch(error => console.error("Error fetching packer names:", error));
  }, []);

  const resetForm = () => {
    setFormData({
      vnum: "",
      vNo: "",
      date: "",
      packerName: "",
      cardNo: "",
      qty: "",
      wt: "",
      packingQuantity: "",
      packingSize: "",
      remark: "",
      pack: "",
      customQty: "",
      customPackingQuantity: "",
    });
    settotalquantity("");
    setFormError({
      vNo: "",
      date: "",
      packerName: "",
      cardNo: "",
      qty: "",
      wt: "",
      packingQuantity: "",
      packingSize: "",
      pack: "",
      customQty: "",
      customPackingQuantity: "",
    });
    setperweight();
    setIsFormEnabled(false);
    setIsNewEntry(false);
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFormError({
      ...formError,
      [e.target.name]: validateField(e.target.name, e.target.value),
    });
  };

  const stopScanner = async () => {
    try {
      if (scannerRef.current) {
        try {
          await scannerRef.current.stop();
        } catch (_) {
          /* already stopped */
        }
        try {
          await scannerRef.current.clear();
        } catch (_) {
          /* ignore */
        }
        scannerRef.current = null;
      }
    } catch (err) {
      console.error("Error stopping scanner:", err);
      scannerRef.current = null;
    } finally {
      setIsScanning(false);
    }
  };

  const closeScanner = async () => {
    await stopScanner();
    setShowScanner(false);
    scanHandledRef.current = false;
  };

  const applyScannedCardNo = async (rawValue) => {
    if (scanHandledRef.current) return;
    scanHandledRef.current = true;

    const scanned = String(rawValue || "").trim();
    if (!scanned) {
      scanHandledRef.current = false;
      return;
    }

    const match = allCardNumbers.find(
      (item) => String(item.cardNo).trim() === scanned
    );
    const cardNo = match ? String(match.cardNo) : scanned;

    setFormData((prev) => ({ ...prev, cardNo }));
    setFormError((prev) => ({
      ...prev,
      cardNo: validateField("cardNo", cardNo),
    }));

    if (match) {
      toast.success(`Card No. ${cardNo} selected`);
    } else {
      toast.warning(
        `Scanned "${cardNo}" — not found in Card No. list. Verify the order card.`
      );
    }

    await closeScanner();
  };

  const openScanner = () => {
    if (!isFormEnabled) {
      toast.info("Click Add first to enable the form, then scan");
      return;
    }
    scanHandledRef.current = false;
    setShowScanner(true);
  };

  useEffect(() => {
    if (!showScanner) return undefined;

    let cancelled = false;

    const startScanner = async () => {
      try {
        setIsScanning(true);
        const scanner = new Html5Qrcode("packing-card-barcode-reader");
        scannerRef.current = scanner;

        await scanner.start(
          { facingMode: "environment" },
          {
            fps: 10,
            qrbox: { width: 280, height: 120 },
            aspectRatio: 1.5,
            formatsToSupport: [
              Html5QrcodeSupportedFormats.CODE_128,
              Html5QrcodeSupportedFormats.CODE_39,
              Html5QrcodeSupportedFormats.EAN_13,
              Html5QrcodeSupportedFormats.EAN_8,
              Html5QrcodeSupportedFormats.QR_CODE,
            ],
          },
          (decodedText) => {
            if (!cancelled) {
              applyScannedCardNo(decodedText);
            }
          },
          () => {}
        );
      } catch (err) {
        console.error("Unable to start camera scanner:", err);
        toast.error(
          err?.message?.includes("NotAllowedError") ||
            err?.name === "NotAllowedError"
            ? "Camera permission denied. Allow camera access and try again."
            : "Unable to start camera. Use HTTPS or localhost, and check camera permissions."
        );
        setShowScanner(false);
        setIsScanning(false);
      }
    };

    // small delay so modal DOM is mounted
    const timer = setTimeout(startScanner, 250);

    return () => {
      cancelled = true;
      clearTimeout(timer);
      stopScanner();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showScanner]);

  const handleAdd = () => {
    if (isNewEntry) {
      setFormData({
        ...formData,
        vNo: formData.vnum,
      });
      console.log(formData);
      const errors = {
        vnum: validateField("vnum", formData?.vnum),
        date: validateField("date", formData?.date),
        packerName: validateField("packerName", formData?.packerName),
        cardNo: validateField("cardNo", formData?.cardNo),
        qty: validateField("qty", formData?.qty),
        wt: validateField("wt", formData?.wt),
        lotNo: validateField("lotNo", formData?.lotNo),
        packingQuantity: validateField(
          "packingQuantity",
          formData?.packingQuantity
        ),
        pack: validateField("pack", formData?.pack),
        customQty: validateField("customQty", formData?.customQty),
        customPackingQuantity: validateField(
          "customPackingQuantity",
          formData?.customPackingQuantity
        ),
      };
      setFormError(errors);
      console.log({ errors });

      if (Object.values(errors).some((error) => error)) return;
      console.log({ formData });

      const finalPackerName = formData.packerName === "Other" ? formData.customPackerName : formData.packerName;

      axios
        .post(
          `${API_BASE_URL}/api/package/create`,
          { ...formData, vNo: formData.vnum, packerName: finalPackerName },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          toast("Packing entry added Successfully");
          fetchAllVNumbers();
          fetchAllData();
          resetForm();

          setTimeout(() => {
            window.location.reload();
          }, 500);
        })
        .catch((error) => {
          console.error("Error adding data:", error);
          const msg =
            error?.response?.data?.message ||
            "Error adding packing entry";
          toast.error(msg);
        });
    } else {
      setIsFormEnabled(true);
      setIsNewEntry(true);
      console.log({ allVNums });
      console.log({ max: Math.max(allVNums) });
      var maxno =
        allVNums.length > 0 ? Math.max(...allVNums.map(Number)) : null;
      console.log(maxno);
      setFormData({
        ...formData,
        vnum: maxno + 1,
        date: new Date().toISOString().split("T")[0],
      });
    }
  };

  const handleUpdate = () => {
    if (isFormEnabled && !isNewEntry) {
      const errors = {
        vnum: validateField("vnum", formData?.vnum),
        date: validateField("date", formData?.date),
        packerName: validateField("packerName", formData?.packerName),
        cardNo: validateField("cardNo", formData?.cardNo),
        qty: validateField("qty", formData?.qty),
        wt: validateField("wt", formData?.wt),
        packingQuantity: validateField(
          "packingQuantity",
          formData?.packingQuantity
        ),
        pack: validateField("pack", formData?.pack),
        customQty: validateField("customQty", formData?.customQty),
        customPackingQuantity: validateField(
          "customPackingQuantity",
          formData?.customPackingQuantity
        ),
      };
      setFormError(errors);
      console.log({ errors });

      const finalPackerName = formData.packerName === "Other" ? formData.customPackerName : formData.packerName;

      if (Object.values(errors).some((error) => error)) return;
      axios
        .put(
          `${API_BASE_URL}/api/package/updatePackage/${formData.vNo}`,
          { ...formData, packerName: finalPackerName },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status === 200) {
            toast("Package updated successfully");
            fetchAllVNumbers();
            fetchAllData();
            resetForm();
          } else {
            toast("Some error occurred");
          }
        })
        .catch((error) => console.error("Error updating data:", error));
    }
  };

  const handleDelete = () => {
    if (isFormEnabled && !isNewEntry) {
      axios
        .delete(`${API_BASE_URL}/api/package/deletePackage/${formData.vNo}`)
        .then((response) => {
          if (response.status === 200) {
            toast("Data deleted successfully");
            fetchAllVNumbers();
            fetchAllData();
            resetForm();

            setTimeout(() => {
              window.location.reload();
            }, 500);
          } else {
            toast("Some Error occurred, please try again later!");
          }
        })
        .catch((error) => {
          console.error("Error deleting data:", error);
          toast("Error occurred while deleting. Check console for details.");
        });
    }
  };

  const sendPrinterData = async (data) => {
    // Cloudflare Tunnel hostname (routes to your Windows printer machine)
    const flaskserver = "https://printer.ehisaab.in/api/print-sticker";

    try {
      const res = await axios.post(flaskserver, data, {
        headers: {
          "Content-Type": "application/json",
          // MUST match PRINT_SECRET in your Flask handler
          "X-Print-Secret": "MY_SUPER_SECRET_12345"
        },
        // no cookies needed for this request
        withCredentials: false
      });

      console.log("Data sent successfully to printer:", res.data);
      toast.success("Print request sent");
    } catch (error) {
      console.error("Failed to send data to printer:", error);
      if (error.response) {
        console.error("Status:", error.response.status, "Data:", error.response.data);
        if (error.response.status === 401) {
          toast.error("Printer unauthorized: wrong secret (X-Print-Secret).");
        } else {
          toast.error(`Printer error: ${error.response.status}`);
        }
      } else {
        toast.error("Cannot reach print service");
      }
    }
  };


  return (
    <>
      <Header />

      <div className="p-2 flex items-center justify-center">
        <div
          className={`bg-gray-200 shadow-xl ${isMaximized ? "w-full h-full" : "w-[800px]"
            }`}>
          <div className="flex items-center justify-between bg-gradient-to-r from-teal-600 to-teal-700 p-0.5">
            <span className="text-white font-semibold px-2">Packing Entry</span>
            <div className="flex gap-0.5">
              {/* <button className="w-4 h-4 flex items-center justify-center hover:bg-slate-50 text-white hover:text-teal-700">
              <span>−</span>
            </button> */}
              <button
                className="w-4 h-4 flex items-center justify-center hover:bg-slate-50 text-white hover:text-teal-700"
                onClick={() => setIsMaximized(!isMaximized)}>
                <span>□</span>
              </button>
              {/* <button className="w-4 h-4 flex items-center justify-center hover:bg-slate-50 text-white hover:text-teal-700">
              <span>×</span>
            </button> */}
            </div>
          </div>

          <div className="p-2">
            <div className="mb-2">
              <div className="flex items-center gap-2 mb-2">
                <div className="flex-1">
                  <label className="block mb-0.5">V. No.</label>
                  <select
                    className="w-full border border-gray-300 rounded px-1 py-0.5"
                    name="vnum"
                    value={formData.vnum}
                    onChange={(e) => {
                      handleInputChange(e);
                      fetchPackageData(e.target.value);
                    }}
                    disabled={isNewEntry}>
                    <option value="">Select V. No.</option>
                    {allVNums.map((vNo) => (
                      <option key={vNo} value={vNo}>
                        {vNo}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-2 bg-[#E0FFFF] p-2 rounded">
                <div>
                  <label className="block mb-0.5">V. No.</label>
                  <input
                    type="number"
                    value={formData.vnum}
                    readOnly
                    name="vNo"
                    onChange={handleInputChange}
                    disabled={!isFormEnabled}
                  />
                  {formError?.vNo && (
                    <p className="text-sm text-red-400 capitalize">
                      {formError?.vnum}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block mb-0.5">Date</label>
                  <input
                    type="date"
                    className="w-full border border-gray-300 rounded px-1 py-0.5"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    disabled={!isFormEnabled}
                  />
                  {formError?.date && (
                    <p className="text-sm text-red-400 capitalize">
                      {formError?.date}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block mb-0.5">Packer Name</label>
                  {/* Dropdown for selecting packer name */}
                  <select
                    className="w-full border border-gray-300 rounded px-1 py-1"
                    name="packerName"
                    value={formData.packerName}
                    onChange={handleInputChange}
                    disabled={!isFormEnabled}
                  >
                    <option value="">Select Packer</option>
                    {[...new Set(allpackerName)].map((value, index) => (
                      <option key={index} value={value} className="text-black">
                        {value}
                      </option>
                    ))}
                    <option value="Other" className="text-black">
                      Other
                    </option>
                  </select>

                  {/* Show text input if "Other" is selected */}
                  {formData.packerName === "Other" && (
                    <input
                      type="text"
                      name="customPackerName"
                      placeholder="Enter custom packer name"
                      value={formData.customPackerName || ""}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: "customPackerName",
                            value: e.target.value,
                          },
                        })
                      }
                      className="w-full border border-gray-300 rounded p-0.5 text-sm mt-2"
                      disabled={!isFormEnabled}
                    />
                  )}

                  {/* Show error message if packerName is invalid */}
                  {formError?.packerName && (
                    <p className="text-sm text-red-400 capitalize">{formError?.packerName}</p>
                  )}
                </div>
              </div>

              <div className="text-center bg-teal-600 my-2 py-1 rounded flex justify-center gap-4 items-center">
                <div className="flex flex-col items-center">
                  <label className="text-white mb-1">Total quantity by Card no</label>
                  <input
                    type="number"
                    className="border border-gray-300 rounded px-1 py-0.5 w-20 text-center"
                    name="pack"
                    value={totalquantity}
                    readOnly
                  />
                </div>

                <div className="flex flex-col items-center">
                  <label className="text-white mb-1">Balance quantity by Card no</label>
                  <input
                    type="number"
                    className="border border-gray-300 rounded px-1 py-0.5 w-20 text-center"
                    name="pack"
                    value={remainingqty}
                    readOnly
                  />
                </div>
              </div>

              <div className="grid grid-cols-4 gap-2 mt-2">
                <div className="">
                  <label className="block mb-0.5">Card No.</label>
                  <div className="flex items-center gap-1">
                    <select
                      className="w-full border border-gray-300 rounded px-1 py-0.5"
                      name="cardNo"
                      value={formData.cardNo}
                      onChange={handleInputChange}
                      disabled={!isFormEnabled}>
                      <option value="">Select Card No.</option>
                      {allCardNumbers.map((tool) => (
                        <option key={tool.cardNo} value={tool.cardNo}>
                          {tool.cardNo}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      title="Scan card barcode"
                      onClick={openScanner}
                      disabled={!isFormEnabled}
                      className={`shrink-0 p-1.5 rounded border border-gray-300 ${
                        isFormEnabled
                          ? "bg-white hover:bg-teal-50 text-teal-700"
                          : "bg-gray-100 text-gray-400 cursor-not-allowed"
                      }`}
                    >
                      <FaCamera className="w-3.5 h-3.5" />
                    </button>
                  </div>
                  {formError?.cardNo && (
                    <p className="text-sm text-red-400 capitalize">
                      {formError?.cardNo}
                    </p>
                  )}
                </div>
                <div className="">
                  <label className="block mb-0.5">Lot No.</label>
                  <select
                    className="w-full border border-gray-300 rounded px-1 py-0.5"
                    name="lotNo"
                    value={formData.lotNo}
                    onChange={handleInputChange}
                    disabled={!isFormEnabled}>
                    <option value="">Select Lot No.</option>
                    {lotnolist.map((tool) => (
                      <option key={tool.lotno} value={tool.lotno}>
                        {tool.lotno}
                      </option>
                    ))}
                  </select>
                  {formError?.lotNo && (
                    <p className="text-sm text-red-400 capitalize">
                      {formError?.lotNo}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block mb-0.5">Est Qty</label>
                  <select
                    className="w-full border border-gray-300 rounded px-1 py-0.5"
                    name="qty"
                    value={isCustomQtyExists ? 'custom' : formData.qty}
                    onChange={handleInputChange}
                    disabled={!isFormEnabled}>
                    <option value="" disabled>
                      Select Est Qty
                    </option>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="custom">Custom</option>
                  </select>

                  {(formData.qty === "custom" || isCustomQtyExists) && (
                    <input
                      type="number"
                      className="w-full border border-gray-300 rounded px-1 py-0.5 mt-2"
                      name="customQty"
                      value={formData.customQty || formData.qty || ""}
                      onChange={handleInputChange}
                      disabled={!isFormEnabled}
                      placeholder="Enter custom quantity"
                    />
                  )}
                  {formError?.qty && (
                    <p className="text-sm text-red-400 capitalize">
                      {formError?.qty}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block mb-0.5">Est Wt. (gm.)</label>
                  <div className="flex flex-col gap-1">
                    <input
                      type="number"
                      className="w-full border border-gray-300 rounded px-1 py-0.5"
                      name="wt"
                      value={formData.wt}
                      onChange={handleInputChange}
                      disabled={!isFormEnabled}
                    // readOnly
                    />
                    {formError?.wt && (
                      <p className="text-sm text-red-400 capitalize">
                        {formError?.wt}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex flex-col ">
                  <label className="block mb-0.5">Packing Quantity</label>
                  <div className="flex  flex-col  gap-1">
                    <select
                      className="w-full border border-gray-300 rounded px-1 py-0.5"
                      name="packingQuantity"
                      value={isCustomPkgQtyExists ? 'custom' : formData.packingQuantity}
                      onChange={handleInputChange}
                      disabled={!isFormEnabled}>
                      <option value="" disabled>
                        Select package quantity
                      </option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                      <option value="1500">1500</option>
                      <option value="2000">2000</option>
                      <option value="5000">5000</option>
                      <option value="10000">10000</option>

                      <option value="custom">Custom</option>
                    </select>
                  </div>

                  {(formData.packingQuantity === "custom" || isCustomPkgQtyExists) && (
                    <input
                      type="number"
                      className="w-full border border-gray-300 rounded px-1 py-0.5 mt-2"
                      name="customPackingQuantity"
                      value={formData.customPackingQuantity || formData.packingQuantity || ""}
                      onChange={handleInputChange}
                      disabled={!isFormEnabled}
                      placeholder="Enter custom packing quantity"
                    />
                  )}
                  {formError?.packingQuantity && (
                    <p className="text-sm text-red-400 capitalize">
                      {formError?.packingQuantity}
                    </p>
                  )}
                </div>
                <div>
                  <label className="block mb-0.5">Pack</label>
                  <div className="flex  flex-col  gap-1">
                    <input
                      type="number"
                      className="w-full border border-gray-300 rounded px-1 py-0.5"
                      name="pack"
                      value={formData.pack}
                      onChange={handleInputChange}
                      disabled={!isFormEnabled}
                    />
                    {formError?.pack && (
                      <p className="text-sm text-red-400 capitalize">
                        {formError?.pack}
                      </p>
                    )}
                  </div>
                </div>
                <div>
                  <label className="block mb-0.5">Packing Weight (Kg)</label>
                  <div className="flex  flex-col  gap-1">
                    <input
                      type="number"
                      className="w-full border border-gray-300 rounded px-1 py-0.5"
                      name="packingSize"
                      value={formData.packingSize}
                      onChange={handleInputChange}
                      disabled={!isFormEnabled}
                      readOnly
                    />
                  </div>
                </div>
                <div>
                  <label className="block mb-0.5">Total Quantity</label>
                  <div className="flex  flex-col  gap-1">
                    <input
                      type="number"
                      className="w-full border border-gray-300 rounded px-1 py-0.5"
                      name="pack"
                      value={formData.totalquantity}
                      disabled={!isFormEnabled}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="bg-[#E0FFFF] p-2 rounded">
            <div className="flex justify-between items-center">
              <div className="flex-1">
                <label className="block mb-0.5">Description</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded px-1 py-0.5"
                  name="remark"
                  value={formData.remark}
                  onChange={handleInputChange}
                  disabled={!isFormEnabled}
                />
              </div>
            </div>
          </div> */}

            <div className="flex justify-between mt-2 bg-teal-600 p-1 flex-wrap ">
              <div className="flex mb-3  lg:m-0  ">
                <div className="flex gap-1">
                  <button
                    className="flex items-center gap-1 px-2 py-0.5 bg-gray-100 hover:bg-gray-200 rounded"
                    onClick={handleAdd}>
                    <FaPlus className="h-3 w-3" />
                    {isNewEntry ? "Submit" : "Add"}
                  </button>
                  <button
                    className="flex items-center gap-1 px-2 py-0.5 bg-gray-100 hover:bg-gray-200 rounded"
                    onClick={handleUpdate}
                  // disabled={!isFormEnabled || isNewEntry}
                  >
                    <FaEdit className="h-3 w-3" />
                    Update
                  </button>
                  <button
                    className="flex items-center gap-1 px-2 py-0.5 bg-gray-100 hover:bg-gray-200 rounded"
                    onClick={handleDelete}
                    disabled={!isFormEnabled || isNewEntry}>
                    <FaTrash className="h-3 w-3" />
                    Delete
                  </button>
                </div>
              </div>
              <div className="flex gap-1">
                {/* <button
                className="flex items-center gap-1 px-2 py-0.5 bg-gray-100 hover:bg-gray-200 rounded"
                onClick={handleSave}
                disabled={!isFormEnabled}>
                <FaSave className="h-3 w-3" />
                Save
              </button> */}
                <button
                  className="flex items-center gap-1 px-2 py-0.5 bg-gray-100 hover:bg-gray-200 rounded"
                  onClick={resetForm}>
                  <FaSync className="h-3 w-3" />
                  Refresh
                </button>

                <button
                  className="flex items-center gap-1 px-2 py-0.5 bg-gray-100 hover:bg-gray-200 rounded"
                  onClick={() => {

                    // include runtime origin so the print server can create QR links back to the correct front-end host
                    const payload = {
                      data: formData,
                      vNo: formData.vNo || formData.vnum,
                      origin: window.location.origin
                    };

                    sendPrinterData(payload);

                    // navigate to preview (unchanged)
                    navigate("/packagepdf", {
                      state: {
                        data: formData,
                        vNo: formData.vNo || formData.vnum,
                      },
                    });

                  }}>
                  <AiOutlinePrinter className="w-3 h-3" />
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showScanner && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-3">
          <div className="bg-white rounded-md shadow-lg w-full max-w-md overflow-hidden">
            <div className="flex items-center justify-between px-3 py-2 border-b bg-teal-700 text-white">
              <h3 className="text-sm font-semibold">Scan Card No. Barcode</h3>
              <button
                type="button"
                onClick={closeScanner}
                className="p-1 rounded hover:bg-teal-600"
                title="Close"
              >
                <FaTimes className="w-3.5 h-3.5" />
              </button>
            </div>
            <div className="p-3">
              <p className="text-xs text-gray-600 mb-2">
                Point the camera at the Card No. barcode on the order PDF.
              </p>
              <div
                id="packing-card-barcode-reader"
                className="w-full overflow-hidden rounded border border-gray-300 bg-black min-h-[240px]"
              />
              {isScanning && (
                <p className="text-xs text-center text-teal-700 mt-2">
                  Scanning…
                </p>
              )}
              <button
                type="button"
                onClick={closeScanner}
                className="mt-3 w-full py-1.5 text-xs bg-gray-200 hover:bg-gray-300 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PackingEntry;
